import { Typography} from '@mui/material'
import thumbNailOne from '../assets/Images/thumbnail-1.png';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

const LoadingPageCard = ({ videolink, videotext }) => {
    return (
        <>
            <div>
                <div className='loading-page'>
                    <a href={videolink} target={'_blank'}>
                        <img src={thumbNailOne} />
                        <div >
                            <PlayArrowIcon sx={{ fontSize: '3.5rem', color: 'black' }} />
                        </div>
                    </a>
                </div>
                <Typography variant='heading' textAlign={'center'}>{videotext}</Typography>
            </div>

        </>
    )
}

export default LoadingPageCard